import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { showConflictDialog } from "./components/ConflictDialog";
import { createStorage, setConflictHandler } from "./lib/storage";
import "./index.css";

// Legacy components reference `window.storage` (originally the Claude Artifact
// persistent store). Assign our API-backed implementation so they keep working
// without modification.
window.storage = createStorage();

// When a PUT conflicts with another user's write, prompt the user via the
// ConflictDialog modal (mounted in App).
setConflictHandler(showConflictDialog);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
